import { Helpers } from '../../helpers';
import { IBusinessAssociate } from '../../interfaces/ibusiness-associate';
import { BusinessAssociateType } from '../business-associate-type';
import { Project } from '../project';
import { Well } from '../well';

export class BusinessAssociateBase {
  BusinessAssociateId: number;
  BAHubId: string | null;
  Name: string | null;
  BusinessAssociateTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Projects_BusinessAssociate?: Array<Project> | null;
  Wells_BusinessAssociate?: Array<Well> | null;
  BusinessAssociateType?: BusinessAssociateType;

  constructor(item?: IBusinessAssociate) {
    if (item) {

      this.BusinessAssociateId = item.BusinessAssociateId;
      this.BAHubId = item.BAHubId;
      this.Name = item.Name;
      this.BusinessAssociateTypeId = item.BusinessAssociateTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Projects_BusinessAssociate = Helpers.createClassArray(Project, item.Projects_BusinessAssociate);
      this.Wells_BusinessAssociate = Helpers.createClassArray(Well, item.Wells_BusinessAssociate);
      this.BusinessAssociateType = new BusinessAssociateType(item.BusinessAssociateType);
    }
  }
}